"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.OpenAPIIndex = void 0;
var json_pointer_1 = require("@criteria/json-pointer");
var json_schema_1 = require("@criteria/json-schema");
var OpenAPIContentIndex_1 = require("../openapi-index/OpenAPIContentIndex");
var JSONPointer_1 = require("../util/JSONPointer");
var uri_1 = require("../util/uri");
var promises_1 = require("../util/promises");
// default configuration
var defaultDefaultJSONSchemaDialect = json_schema_1.metaSchemaURIDraft2020_12;
var OpenAPIIndex = /** @class */ (function (_super) {
    __extends(OpenAPIIndex, _super);
    function OpenAPIIndex(configuration) {
        var _this = this;
        var _a;
        _this = _super.call(this, {
            cloned: configuration.cloned,
            retrieve: configuration.retrieve
        }) || this;
        _this.references = new Map();
        _this.openAPIContentIndex = new OpenAPIContentIndex_1.OpenAPIContentIndex();
        _this.defaultJSONSchemaDialect = (_a = configuration.defaultJSONSchemaDialect) !== null && _a !== void 0 ? _a : defaultDefaultJSONSchemaDialect;
        return _this;
    }
    OpenAPIIndex.prototype.isObjectIndexed = function (object) {
        if (this.openAPIContentIndex.isObjectIndexed(object)) {
            return true;
        }
        return _super.prototype.isObjectIndexed.call(this, object);
    };
    OpenAPIIndex.prototype.isURIIndexed = function (uri) {
        if (this.openAPIContentIndex.isURIIndexed(uri)) {
            return true;
        }
        return _super.prototype.indexedObjectWithURI.call(this, uri);
    };
    OpenAPIIndex.prototype.indexedObjectWithURI = function (uri) {
        if (this.openAPIContentIndex.isURIIndexed(uri)) {
            return this.openAPIContentIndex.indexedObjectWithURI(uri);
        }
        return _super.prototype.indexedObjectWithURI.call(this, uri);
    };
    OpenAPIIndex.prototype.infoForIndexedObject = function (object) {
        if (this.openAPIContentIndex.isObjectIndexed(object)) {
            return this.openAPIContentIndex.infoForIndexedObject(object);
        }
        return _super.prototype.infoForIndexedObject.call(this, object);
    };
    OpenAPIIndex.prototype.addRootOpenAPI = function (rootOpenAPI, baseURI) {
        var _a;
        rootOpenAPI = this.addDocument(rootOpenAPI, baseURI);
        var rootOpenAPIMetadata = {
            type: 'openapi',
            openAPIVersion: rootOpenAPI.openapi,
            metaSchemaURI: (_a = rootOpenAPI.jsonSchemaDialect) !== null && _a !== void 0 ? _a : this.defaultJSONSchemaDialect
        };
        return this.addOpenAPIObjects(rootOpenAPI, baseURI, rootOpenAPIMetadata);
    };
    OpenAPIIndex.prototype.addOpenAPIObjects = function (rootObject, baseURI, metadata) {
        var _this = this;
        var foundReferences = this.openAPIContentIndex.addContentFromRoot(rootObject, baseURI, metadata);
        foundReferences.forEach(function (info, reference) {
            _this.references.set(reference, info);
        });
        // Help prevent Maximum call stack size exceeded errors
        var unindexedReferences = __spreadArray([], __read(foundReferences.values()), false).filter(function (info) {
            if (_this.isURIIndexed(info.resolvedURI)) {
                return false;
            }
            var _a = (0, uri_1.splitFragment)(info.resolvedURI), absoluteURI = _a.absoluteURI, fragment = _a.fragment;
            return !_this.isURIIndexed(absoluteURI);
        });
        return (0, promises_1.chainForEach)(unindexedReferences.values(), function (info) {
            if (_this.isURIIndexed(info.resolvedURI)) {
                return;
            }
            var _a = (0, uri_1.splitFragment)(info.resolvedURI), absoluteURI = _a.absoluteURI, fragment = _a.fragment;
            var documentOrPromise;
            if (_this.isURIIndexed(absoluteURI)) {
                // documentOrPromise = this.indexedObjectWithURI(absoluteURI)
            }
            else {
                documentOrPromise = _this.addDocumentWithURI(absoluteURI);
            }
            return (0, promises_1.chain)(documentOrPromise, function (document) {
                if (document) {
                    if (fragment && (0, JSONPointer_1.isJSONPointer)(fragment)) {
                        var rootObject_1 = (0, json_pointer_1.evaluateJSONPointer)(fragment, document);
                        if (rootObject_1) {
                            return _this.addOpenAPIObjects(rootObject_1, info.resolvedURI, info.metadata);
                        }
                    }
                    else {
                        return _this.addOpenAPIObjects(document, absoluteURI, info.metadata);
                    }
                }
            });
        });
    };
    return OpenAPIIndex;
}(json_schema_1.DocumentIndex));
exports.OpenAPIIndex = OpenAPIIndex;
